import PocketBase from 'pocketbase'

const pb = new PocketBase(import.meta.env.VITE_BASE_URL ?? window.location.origin)

export { pb }
